// extracted by mini-css-extract-plugin
export default {"loadingSec":"loading_loadingSec__WgX-g","loadingWrapper":"loading_loadingWrapper__n3Pev","loadingImage":"loading_loadingImage__dQA1g","spin":"loading_spin__0fiCh"};